import React from 'react';
import { IntercomProvider } from 'react-use-intercom';

import { ProvideAuth, useAuth } from 'context/Auth';
import { ProvideScheme } from 'context/Schema';
import { ProvideApp } from 'context/App';

import Routes from './routes';
import Misc from './Components/Misc';
import { isIframe } from 'utils';
import { ErrorBoundary } from '@sentry/react';
import { Loader } from '../styles/common';
import 'init';
import { StyleSheetManager, ThemeProvider, WebTarget } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';
import { configTheme } from '../utils/configTheme';
import { GlobalStyles } from '../styles/globalStyles';

const INTERCOM_APP_ID = window._env_.INTERCOM_APP_ID;
export const INTERCOM_SHOULD_INITIALIZE = window._env_.STAGE !== 'local' && !isIframe();

// styled-components v6 forwards all props to the DOM; keep v5 behaviour (filter unknown props on HTML elements)
const shouldForwardProp = (propName: string, target: WebTarget) => (typeof target === 'string' ? isPropValid(propName) : true);

const App = () => (
  <ProvideAuth>
    <ProvideScheme>
      <ProvideApp>
        <IntercomProvider
          autoBoot
          shouldInitialize={INTERCOM_SHOULD_INITIALIZE}
          appId={INTERCOM_APP_ID}
        >
          <StyleSheetManager shouldForwardProp={shouldForwardProp}>
            <AppInner />
          </StyleSheetManager>
        </IntercomProvider>
      </ProvideApp>
    </ProvideScheme>
  </ProvideAuth>
);

const AppInner = () => {
  const { user } = useAuth();

  return (
    <ThemeProvider theme={configTheme({
      colors: user?.broker?.ui_config?.colors
    })}>
      <GlobalStyles />
      <ErrorBoundary fallback={<Loader />}>
        <Routes />
        <Misc />
      </ErrorBoundary>
    </ThemeProvider>
  );
};

export default App;
